/* eslint-disable no-unused-vars */
import {
  ADMIN,
  ALUMNI,
  COHORT,
  EMPLOYERS,
  EVENTS,
  FEED,
  HOME,
  JOBS,
} from "./routes";

const linksByGroup = {
  admin: [
    { href: FEED, label: "Home" },
    // { href: EVENTS, label: "Events" },
    { href: ALUMNI, label: "Alumni" },
    { href: ADMIN, label: "Admin" },
    // { href: COHORT, label: "Cohort" },
    // { href: JOBS, label: "Jobs" },
    // { href: EMPLOYERS, label: "Employers" },
  ],
  alumni: [
    { href: FEED, label: "Home" },
    // { href: EVENTS, label: "Events" },
    { href: ALUMNI, label: "Alumni" },
    // { href: COHORT, label: "Cohort" },
    // { href: JOBS, label: "Jobs" },
  ],
  employers: [
    { href: FEED, label: "Home" },
    // { href: EVENTS, label: "Events" },
    { href: ALUMNI, label: "Alumni" },
    // { href: EMPLOYERS, label: "Employers" },
  ],
  public: [
    { href: HOME, label: "Home" },
    // { href: EVENTS, label: "Events" },
  ],
};

export default linksByGroup;
